import type { Notification, Priority } from '../../api/notifications';
export const categoryLabels: Record<string, string> = { upgrade: '系统升级', problem: '问题通知', recovery: '问题恢复', feature: '功能更新', other: '其他通知' };
export const priorityLabels: Record<Priority, string> = { normal: '一般', important: '重要', urgent: '紧急' };
export const priorityDescriptions: Record<Priority, string> = {
  normal: '右上角展示 6 秒后自动已读；悬停或查看详情时暂停。',
  important: '右上角持续显示，接收人点击“我已知晓”后隐藏。',
  urgent: '右上角优先持续显示，接收人点击“我已知晓”后隐藏。',
};
export const noticeTime = (value: string | null) => value ? new Date(value).toLocaleString('zh-CN', { hour12: false }) : '未发布';
export function sortNotices(items: Notification[]) {
  const weight: Record<Priority, number> = { urgent: 3, important: 2, normal: 1 };
  return [...items].sort((a, b) => weight[b.priority] - weight[a.priority] || Number(b.pinned) - Number(a.pinned) || (b.published_at || '').localeCompare(a.published_at || ''));
}
